import React from 'react'
import { Card, Typography } from 'antd';
import { table } from './struct';
import { FacultiesTable } from './tables';

const { Title } = Typography;

const Faculties = () => {
    return (
        <Card {...table.wrapper}>
            <Title>Faculties List</Title>
            <FacultiesTable />
        </Card>
    )
}

export default Faculties